import React from 'react';

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const stylesBt = theme => ({
    button: {
        margin: theme.spacing.unit,
        position: 'fixed',
        bottom: theme.spacing.unit * 2,
        right: theme.spacing.unit * 2,
    },
});
let tick;
class CountDown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      second:props.second?props.second:0,

      isEnd:false,


    }
    //console.log(props);

  }
  componentDidMount(){
      this.startShowing();
  }
  startShowing(){
    if(this.state.second>0&&!this.state.isEnd)
    {
      let _this=this;

      //console.log(interval);
       tick = setInterval(function(){
  // do your thing
  let second = _this.state.second;
    if(second>0)
    {
      second--;
    }
    if(_this.props.onUpdateRemain)
    {
      _this.props.onUpdateRemain(second);
    }
        if(second==0)
        {
        clearInterval(tick);
        _this.props.isEnd();
        _this.setState({isEnd:true});
      }
      else {
        _this.setState({second});
      }



    },1000);
  }
  }
  componentWillUnmount(){
    if(tick)
    clearInterval(tick);
  }
  // componentWillReceiveProps(props)
  // {
  //   if(props.second>0&&this.state.isEnd)
  //   {
  //     this.setState({showing:true,isEnd:false,index:0,numbers:props.numbers,second:props.second},()=>this.startShowing());
  //   }
  // }

  getDisplayText(){
    let rel = '';
    let {second,isEnd} = this.state;

    if(isEnd)
    rel = '0';
    else {
      rel = second;
    }


    return rel;
  }

    render() {
        const { classes, width,size } = this.props;
        let {second,isEnd} = this.state;

        return (
            <div style={{fontSize:size?size:"1.6rem",fontFamily:'arial',display:'inline-block'}}>
                {this.getDisplayText()}
            </div>
        );
    }
}

CountDown.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(stylesBt)(CountDown);
